import React, { useEffect, useContext, Suspense } from "react"
import { GlobalContext } from "@Context/context/GlobalState"
import LocalShippingIcon from "@material-ui/icons/LocalShipping"
import { useTranslation } from "react-i18next"
import useUserPermissions from "@Hooks/useUserPermissions"
import rsc from "@Config/resources"
import { useHistory } from "react-router"
import { LoadComponentByCondition } from "@Methods"
const Component = new LoadComponentByCondition("TableCalendar").render()

const CalendarScreen = () => {
  const { t } = useTranslation("global")
  const { handleRoutingBreadcrumbs } = useContext(GlobalContext)
  const { permission, checking } = useUserPermissions({
    resources: [rsc.CaListCalendar],
  })
  const history = useHistory()

  useEffect(() => {
    if (!checking) {
      if (!permission[rsc.CaListCalendar]) return history.goBack()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checking])

  useEffect(() => {
    handleRoutingBreadcrumbs({
      titleHeader: t("calendar"),
      routes: [
        { name: t("logistics"), route: "/calendar" },
        { name: t("calendar"), route: "/calendar" },
      ],
      icon: <LocalShippingIcon style={{ marginRight: 5, opacity: 0.5 }} />,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Suspense fallback>
      <Component />
    </Suspense>
  )
}

export default CalendarScreen
